class PaymentSummary {
  public readonly serviceMonth: Date;
  public readonly payoutedAt?: Date;
  public readonly payoutItemId?: string;
  public readonly paymentCurrency: string;
  public readonly sumPaymentAmount: number;
  constructor({
    serviceMonth,
    payoutedAt,
    payoutItemId,
    paymentCurrency,
    sumPaymentAmount,
  }: {
    serviceMonth: Date;
    payoutedAt?: Date;
    payoutItemId?: string;
    paymentCurrency: string;
    sumPaymentAmount: number;
  }) {
    this.serviceMonth = serviceMonth;
    this.payoutedAt = payoutedAt;
    this.payoutItemId = payoutItemId;
    this.paymentCurrency = paymentCurrency;
    this.sumPaymentAmount = sumPaymentAmount;
  }

  public static fromJSON = (value: any) => {
    const { service_month, payouted_at, payout_item_id, payment_currency, sum_payment_amount } = Object.assign(
      {},
      value,
    );

    const serviceMonth = new Date(Date.parse(service_month));
    if (serviceMonth.toString() === 'Invalid Date') throw new TypeError('.service_month must be a Date');
    const payoutedAt = new Date(Date.parse(payouted_at));
    if (payouted_at && payoutedAt.toString() === 'Invalid Date') throw new TypeError('.payouted_at must be a Date');
    if (payout_item_id && typeof payout_item_id !== 'number') throw new TypeError('.payout_item_id must be a number');
    if (typeof payment_currency !== 'string') throw new TypeError('.payment_currency must be a string');
    if (typeof sum_payment_amount !== 'string') throw new TypeError('.sum_payment_amount must be a string');

    return new PaymentSummary({
      serviceMonth,
      payoutedAt: payouted_at ? payoutedAt : undefined,
      payoutItemId: payout_item_id ? String(payout_item_id) : undefined,
      paymentCurrency: payment_currency,
      sumPaymentAmount: Number(sum_payment_amount),
    });
  };
}

export default PaymentSummary;
